// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__RlAAR","appList":"NavBar_appList__oA7hT","userPanel":"NavBar_userPanel__aVg07"};